import { render, staticRenderFns } from "./EmailConfirmedPage.vue?vue&type=template&id=5ac458da"
import script from "./EmailConfirmedPage.vue?vue&type=script&lang=js"
export * from "./EmailConfirmedPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports